import { render, staticRenderFns } from "./coupons.vue?vue&type=template&id=5296faf6&scoped=true&"
import script from "./coupons.vue?vue&type=script&lang=js&"
export * from "./coupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5296faf6",
  null
  
)

export default component.exports